export const arrayIncludesSubset = <ArrayType = unknown>(parent: ArrayType[], subset: ArrayType[]): boolean => {
  const parentSet = new Set<ArrayType>(parent)
  return subset.every(subsetItem => parentSet.has(subsetItem))
}
